import { Box } from '@quintoandar-tokko/jopijs';
import styles from './performanceCard.module.scss';

export default function PerformanceCardContent({
  className = '',
  children,
  ...rest
}) {
  return (
    <Box className={`${styles.content} ${className}`} {...rest}>
      {children}
    </Box>
  );
}
